import { FormControl, FormHelperText, MenuItem } from '@material-ui/core';
import { observer } from 'mobx-react';
import React from 'react';

import { CancelContractManualRequestDto } from '../../../core/api/dtos';
import { WrappedField } from '../../../core/common/forms';
import { injectTSDI } from '../../../core/common/tsdi';
import { I18n } from '../../../core/i18n';
import { StyledSelect } from '../../../core/styles';
import { StyledBlackInputLabel, StyledBlackLabel } from '../../styles';

interface TypeSelectProps {
    cancellationTypeField: WrappedField<
        CancelContractManualRequestDto['cancellationType']
    >;
    helperTextExtraordinaryTermination: string;
    'data-role'?: string;

    onChange(event: React.ChangeEvent<{ name?: string; value: unknown }>): void;
}

export const TypeSelect = observer((props: TypeSelectProps) => {
    const { translate } = injectTSDI(I18n);
    const {
        cancellationTypeField,
        onChange,
        helperTextExtraordinaryTermination
    } = props;
    return (
        <FormControl
            fullWidth
            required
            variant="outlined"
            error={Boolean(cancellationTypeField.error)}
        >
            <StyledBlackInputLabel
                id={`contract-termination-type-label-${props['data-role']}`}
                htmlFor={`${props['data-role']}-input`}
            >
                {translate('public.content.terminate.contract.type')}
            </StyledBlackInputLabel>
            <StyledSelect
                inputProps={{ id: `${props['data-role']}-input` }}
                labelId={`contract-termination-type-label-${props['data-role']}`}
                id="contract-termination-type"
                value={cancellationTypeField.value ?? ''}
                label={
                    <StyledBlackLabel>
                        {translate('public.content.terminate.contract.type')}
                    </StyledBlackLabel>
                }
                onChange={onChange}
                data-role={props['data-role']}
            >
                <MenuItem
                    key="ORDINARY_CANCELLATION"
                    value="ORDINARY_CANCELLATION"
                    data-role={`${props['data-role']}-ordinary`}
                >
                    {translate(
                        'public.content.terminate.contract.type.ordinary'
                    )}
                </MenuItem>
                <MenuItem
                    key="EXTRAORDINARY_CANCELLATION"
                    value="EXTRAORDINARY_CANCELLATION"
                    data-role={`${props['data-role']}-extraordinary`}
                >
                    {translate(
                        'public.content.terminate.contract.type.extraordinary'
                    )}
                </MenuItem>
            </StyledSelect>
            <FormHelperText>
                {cancellationTypeField.value === 'EXTRAORDINARY_CANCELLATION'
                    ? helperTextExtraordinaryTermination
                    : cancellationTypeField.error
                      ? translate(cancellationTypeField.error)
                      : undefined}
            </FormHelperText>
        </FormControl>
    );
});
